module.exports = __webpack_public_path__ + "img/cover-2.b1df4690.jpg";